import { Grid, Typography, IconButton, Container } from '@mui/material';
import LoadingSkeleton from 'components/core/LoadingSkeleton/LoadingSkeleton';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

export interface PageNavSectionProps {
  isLoading?: boolean;
  title?: string;
  hasBackIcon?: boolean;
  onClickGoBack?: () => void;
  isBackDisabled?: boolean;
}

export const PageNavSection = ({
  isLoading = false,
  hasBackIcon = false,
  title = 'Please Add a Title',
  onClickGoBack = () => null,
  isBackDisabled = false,
}: PageNavSectionProps) => {
  return (
    <Container maxWidth="lg">
      <Grid container spacing={2}>
        <Grid item xs={12} my={4}>
          <LoadingSkeleton isLoading={isLoading} scaleOneToOne>
            <Typography variant="h5">
              {hasBackIcon ? (
                <IconButton
                  onClick={onClickGoBack}
                  size="small"
                  sx={{ marginRight: 1, marginLeft: '-4px', marginTop: '-4px' }}
                  disabled={isBackDisabled}
                >
                  <ArrowBackIosIcon />
                </IconButton>
              ) : null}
              {title}
            </Typography>
          </LoadingSkeleton>
        </Grid>
      </Grid>
    </Container>
  );
};
